import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the collaboratorsImport state domain
 */

const selectCollaboratorsImportDomain = (state) =>
  state.get("collaboratorsImport", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsDownloading = () =>
  createSelector(selectCollaboratorsImportDomain, (state) =>
    state.get("isDownloading")
  )

export const makeSelectIsUploading = () =>
  createSelector(selectCollaboratorsImportDomain, (state) =>
    state.get("isUploading")
  )
/**
 * Default selector used by CollaboratorsImport
 */

const makeSelectCollaboratorsImport = () =>
  createSelector(selectCollaboratorsImportDomain, (substate) => substate.toJS())

export default makeSelectCollaboratorsImport
export { selectCollaboratorsImportDomain }
